
import {
    FIREWEATHER_API_URL
} from '../../../env';

import {
    authClient
} from '../../../okta-auth';

/**
 * Station data should consist of the following format
 * {
 *  HistoricForecast: [
 *      {
 *          DewPoint: null
 *          Gust: null
 *          Humidity: number
 *          IsForecast: boolean
 *          IsWindCalculated: boolean
 *          Rainfall10AM: null
 *          Rainfall9AM: null
 *          StationDateTicks: number
 *          StationDateTime: string
 *          StationId: number
 *          StationName: string
 *          Temperature: number
 *          WeatherObservationId: number
 *          WindDirDeg: number
 *          WindDirection: string
 *          WindSpeed: number
 *          wind_src: null
 *      }
 *  ],
 *  Observations: [
 *      {
 *          DewPoint: number,
 *          Gust: null,
 *          Humidity: number,
 *          IsForecast: boolean,
 *          IsWindCalculated: boolean,
 *          Rainfall10AM: number
 *          Rainfall9AM: number,
 *          StationDateTicks: number,
 *          StationDateTime: string,
 *          StationId: number,
 *          StationName: string,
 *          Temperature: number,
 *          WeatherObservationId: number,
 *          WindDirDeg: null,
 *          WindDirection: null,
 *          WindSpeed: null,
 *          wind_src
 *      }
 *  ],
 *  StationInfo: {
 *      CsDashboardId: null,
 *      DeploymentStatus: null,
 *      Description: string,
 *      Elevation: number,
 *      FTSID: null,
 *      ForecastDistrictId: string,
 *      FunctionalStatus: null,
 *      InList: null,
 *      JurisdictionId: number,
 *      JurisdictionName: string,
 *      Latitiude: string,
 *      LinkUrl: string,
 *      Longitude: number,
 *      StationAnemometerHeight: null,
 *      StationName: string,
 *      StationNumber: string,
 *      StreetAddress: null,
 *      Tz: string,
 *      UnitType: string,
 *      WMOID: number,
 *      WarningValid: null,
 *      WeatherStationId: number
 *  }
 * }
 * @param {*} detailsContainer 
 * @param {*} stationData 
 */
export function drawStationHeader(detailsContainer, stationData) {
    const btnFontSize = '12px';
    const stationName = stationData['StationInfo']['StationName'];

    const header = $(`<h2>${stationName}</h2>`);
    header.css({
        textAlign: 'center'
    });

    // Add the buttons
    const buttonContainer = $(`<div></div>`);
    buttonContainer.css({
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center'
    })

    // Download button
    const downloadBtn = $(`<button class="btn btn-link">` + 
        `Download` + 
    `</button>`);
    downloadBtn.css({
        fontSize: btnFontSize
    });

    // Handle the download button on-click
    downloadBtn.on('click', function() {
        let baseUrl = FIREWEATHER_API_URL;
        const { idToken, accessToken, refreshToken } = authClient.tokenManager.getTokensSync();
        
        baseUrl += `/weather-stations/${stationData['StationInfo']['WeatherStationId']}/download`;

        $.ajax({
            url: baseUrl,
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${accessToken.accessToken}`
            },
            xhrFields: {
                responseType: 'blob' // Important for handling binary data
            },
            success: function (result) {
                // The result should be a blob (check this when debugging)
                // console.log(result);

                // Create a link element
                var a = document.createElement('a');
                var url = window.URL.createObjectURL(result);

                // Set the link's href to the Blob URL
                a.href = url;
                a.download = `${stationData['StationInfo']['StationName']}.csv`; // Set the file name
                document.body.appendChild(a);
                a.click();

                // Remove the link and revoke the Blob URL
                a.remove();
                window.URL.revokeObjectURL(url);
                
            },
            error: function(xhr, status, error) {
                console.error(error);
            }
        })
        // https://shared-fireweather.dev.apps.rfs.nsw.gov.au/api/weather-stations/82/download
    });

    buttonContainer.append(downloadBtn);

    // Open in new tab button
    const newTab = $(`<button class="btn btn-link">` + 
        `Open in new tab` +
    `</button>`);
    newTab.css({
        fontSize: btnFontSize
    });

    newTab.on('click', function() {
        let baseUrl = 'chart.html';

        const lat = localStorage.getItem('fwfv_clicked_lat');
        const lon = localStorage.getItem('fwfv_clicked_lon');
        const currLayer = localStorage.getItem('fwfv_clicked_layer');

        let params = {
            layer: currLayer,
            lon: lon,
            lat: lat,
            id: stationData['StationInfo']['WeatherStationId']
        }

        let url = baseUrl + '?' + $.param(params);

        window.open(url, '_blank');
    });

    buttonContainer.append(newTab);

    // FCC View button
    const fccView = $(`<button class="btn btn-link">` + 
        `Open FCC view` +
    `</button>`);
    fccView.css({
        fontSize: btnFontSize
    });

    fccView.on('click', function() {
        let baseUrl = 'fcc.html';

        let params = {
            id: stationData['StationInfo']['WeatherStationId']
        }

        let url = baseUrl + '?' + $.param(params);

        window.open(url, '_blank');
    })

    buttonContainer.append(fccView);
    
    // Open External Station Page
    const externalStation = $(`<button class="btn btn-link">` + 
        `Open External Station Page` +
    `</button>`);
    externalStation.css({
        fontSize: btnFontSize
    });
    externalStation.on('click', function() {
        window.open(stationData['StationInfo']['LinkUrl'], '_blank');
    })
    
    buttonContainer.append(externalStation);

    detailsContainer.append(header);
    detailsContainer.append(buttonContainer);
}